var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225 195",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:url(#linear-gradient);}.cls-2{fill:#eabb8c;}.cls-16,.cls-3{opacity:0.39;mix-blend-mode:multiply;fill:url(#linear-gradient-2);}.cls-14,.cls-3{clip-path:url(#clip-path);}.cls-15,.cls-4{fill:#f7c5a9;}.cls-21,.cls-4{opacity:0.72;}.cls-11,.cls-13,.cls-4{mix-blend-mode:overlay;}.cls-5{isolation:isolate;}.cls-19,.cls-6,.cls-9{fill:none;stroke-miterlimit:10;}.cls-6,.cls-9{stroke:#f90000;}.cls-6{stroke-width:1.0279px;}.cls-7{fill:#f90000;}.cls-8{font-size:9.54348px;font-family:Calibri-Bold,\n            Calibri;font-weight:700;}.cls-9{stroke-width:1.01582px;}.cls-10{fill:#bf9162;}.cls-11{opacity:0.34;fill:url(#linear-gradient-3);}.cls-12{clip-path:url(#clip-path-2);}.cls-13{fill:#efb38b;opacity:0.69;}.cls-17{clip-path:url(#clip-path-4);}.cls-18{clip-path:url(#clip-path-5);}.cls-19{stroke:#212121;stroke-width:0.26497px;opacity:0.35;mix-blend-mode:soft-light;}.cls-20{fill:#763718;}.cls-22{fill:#773507;}\n        "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 27.85727,
    y1: 86.55877,
    x2: 74.27664,
    y2: 86.55877,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c49a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25592,
    stopColor: "#ba8c57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.60953,
    stopColor: "#b07f53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94413,
    stopColor: "#ad7b52"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 27.85727,
    y1: 45.883,
    x2: 178.87148,
    y2: 45.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c49a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#c2985a"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61141,
    stopColor: "#b97c57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.72602,
    stopColor: "#b26754"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.83818,
    stopColor: "#ae5a53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.94413,
    stopColor: "#ad5652"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.452 30.376 178.871 61.39 74.277 61.39 27.857 30.376 132.452 30.376"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 74.27664,
    y1: 102.06571,
    x2: 178.87148,
    y2: 102.06571,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c49a5b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.15143,
    stopColor: "#ba8c57"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.36067,
    stopColor: "#b07f53"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.55866,
    stopColor: "#ad7b52"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#594136"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.857 30.376 74.277 61.39 74.277 142.741 27.857 111.728 27.857 30.376"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-3",
    points: "132.452 30.376 178.871 61.39 74.277 61.39 27.857 30.376 132.452 30.376"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "39.459 39.945 149.635 39.945 168.332 49.102 49.539 48.625 39.459 39.945"
  })))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "medium") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 178.79574,
    y1: 161.01006,
    x2: 142.04162,
    y2: 161.23401
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "174.649 157.918 174.836 164.55 180.274 161.122 174.649 157.918"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 73.74843,
    y1: 161.35082,
    x2: 108.2331,
    y2: 161.56509
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "77.895 158.259 77.861 164.624 72.797 161.31 77.895 158.259"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 64.11613,
    y1: 154.66003,
    x2: 49.98835,
    y2: 144.72118
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "62.534 149.735 58.837 155.245 65.121 155.755 62.534 149.735"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 21.80217,
    y1: 123.32751,
    x2: 36.96554,
    y2: 134.27629
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "26.974 123.216 23.252 128.38 21.051 122.742 26.974 123.216"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(112.90725 164.35385)"
  }, "45 cm"), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(182.77346 106.72396)"
  }, "35 cm"), /*#__PURE__*/React.createElement("line", {
    className: "cls-9",
    x1: 190.35251,
    y1: 141.4785,
    x2: 190.1601,
    y2: 110.63876
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "193.445 137.429 186.812 137.611 190.353 142.759 193.445 137.429"
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-6",
    x1: 190.01711,
    y1: 63.8548,
    x2: 190.01711,
    y2: 91.94222
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-7",
    points: "193.109 68.002 186.744 67.968 190.017 62.22 193.109 68.002"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-8",
    transform: "translate(26.81741 142.85092)"
  }, "35 cm"), /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    x: 74.27664,
    y: 61.38994,
    width: 104.59485,
    height: 81.35155
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-11",
    x: 74.27664,
    y: 61.38994,
    width: 104.59485,
    height: 81.35155
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "27.857 30.376 74.277 61.39 74.277 142.741 27.857 111.728 27.857 30.376"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-13",
    points: "41.653 82.68 41.653 36.701 55.199 39.372 55.199 92.219 41.653 82.68"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.452 30.376 178.871 61.39 74.277 61.39 27.857 30.376 132.452 30.376"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-15",
    points: "39.459 39.945 149.635 39.945 168.332 49.102 49.539 48.625 39.459 39.945"
  })), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "132.452 30.376 178.871 61.39 74.277 61.39 27.857 30.376 132.452 30.376"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-16",
    points: "132.452 30.376 178.871 61.39 74.277 61.39 27.857 30.376 132.452 30.376"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-17"
  }, /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "39.459 39.945 149.635 39.945 168.332 49.102 49.539 48.625 39.459 39.945"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("line", {
    className: "cls-19",
    x1: 162.60824,
    y1: 42.99711,
    x2: 42.79777,
    y2: 42.99711
  }))), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M165.23753,67.61591a7.49591,7.49591,0,1,1-7.31561,7.55957A7.1916,7.1916,0,0,1,165.23753,67.61591Zm.00772.87754c-3.60932.03177-6.29283,2.73233-6.25815,6.67265.03468,3.94009,2.76531,6.59342,6.37463,6.56165s6.2927-2.73274,6.258-6.67283C171.58508,71.11459,168.85469,68.46169,165.24525,68.49345Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 165.2819,
    y: 81.6899,
    width: 8.81636,
    height: 0.86241,
    transform: "translate(-0.71617 1.4966) rotate(-0.50426)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "174.062 82.988 176.306 82.063 174.046 81.177 174.062 82.988"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-20",
    d: "M159.36038,82.66246A7.49588,7.49588,0,1,1,166.676,75.103,7.19154,7.19154,0,0,1,159.36038,82.66246Zm-.00772-.87743c3.60932-.03176,6.29282-2.73238,6.25815-6.67271-.03468-3.9401-2.76531-6.59341-6.37463-6.56164s-6.29272,2.73273-6.258,6.67283C153.01282,79.16383,155.74322,81.8168,159.35266,81.785Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-20",
    x: 150.49966,
    y: 67.72612,
    width: 8.81636,
    height: 0.8624,
    transform: "translate(-0.59384 1.36596) rotate(-0.50426)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-20",
    points: "150.536 67.29 148.292 68.215 150.552 69.101 150.536 67.29"
  }), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M103.39473,141.277a6.94359,6.94359,0,1,1,6.66412-7.21226A6.95141,6.95141,0,0,1,103.39473,141.277Zm-.52608-13.31793a6.38473,6.38473,0,1,0,6.63178,6.12773A6.392,6.392,0,0,0,102.86865,127.95905Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M106.56988,135.35414l.00013-.00017.04476.054.01111-.00044c.00843-.00033.00718-.032.00606-.04761a3.55064,3.55064,0,0,0-6.9316.26427c.00437.04494.0628-.00382.0628-.00382h0a.66527.66527,0,0,1,.50124-.22034.65568.65568,0,0,1,.52578.19019.076.076,0,0,0,.12236-.00484.74152.74152,0,0,1,1.03492-.04088.076.076,0,0,0,.1224-.00483.74146.74146,0,0,1,1.03487-.04088.076.076,0,0,0,.1224-.00484.74146.74146,0,0,1,1.03487-.04088.076.076,0,0,0,.1224-.00483.74152.74152,0,0,1,1.03492-.04088.076.076,0,0,0,.12236-.00484.65572.65572,0,0,1,.50914-.23107A.66252.66252,0,0,1,106.56988,135.35414Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M103.01468,139.36736l-.00473.00019h0a.51868.51868,0,0,1-.53338-.49744.27945.27945,0,0,1,.46424-.22044l-.23835-6.03382a.27943.27943,0,0,1,.55843-.02205l.24631,6.23559a.51868.51868,0,0,1-.49252.538Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M102.34306,131.6511a.57992.57992,0,1,1-.85187-.78712,6.4701,6.4701,0,0,1,1.39578-.65606A6.46958,6.46958,0,0,1,102.34306,131.6511Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M105.30232,130.96092a.57992.57992,0,1,1-.85187-.78712,6.46972,6.46972,0,0,1,1.39578-.65606A6.47159,6.47159,0,0,1,105.30232,130.96092Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M107.13574,132.7738a.57993.57993,0,0,1-.85188-.78713,6.47068,6.47068,0,0,1,1.39578-.656A6.47111,6.47111,0,0,1,107.13574,132.7738Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M84.84528,141.39531a6.91934,6.91934,0,1,1,6.64086-7.18708A6.92716,6.92716,0,0,1,84.84528,141.39531ZM84.321,128.12389a6.36243,6.36243,0,1,0,6.60862,6.10632A6.3696,6.3696,0,0,0,84.321,128.12389Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M80.404,135.20961l.6136.567a.28971.28971,0,0,0,.20917.07707l.88868-.0351.34023-.82382a.19452.19452,0,0,1,.24018-.11064l.079.02579a.1142.1142,0,0,0,.13053-.17181l-.66329-.99729a.42019.42019,0,0,0-.40148-.18424l-1.07348.133a.11419.11419,0,0,0-.04061.21359.19455.19455,0,0,1,.08832.24075Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M82.91292,136.248l-1.66682.09468a.77567.77567,0,0,1-.56057-.20658l-.42795-.39546a.6781.6781,0,0,0,.11229.35495l1.20643,1.8138a.6793.6793,0,0,0,.5934.30254l.85867-.03517a.96628.96628,0,1,0-.11545-1.92876Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M85.19176,131.40791l-.42012.78391.53775.71079a.19449.19449,0,0,1-.02631.26311l-.06228.05507a.11419.11419,0,0,0,.082.19958l1.19585-.06641a.42008.42008,0,0,0,.3623-.2527l.42936-.99282a.11421.11421,0,0,0-.16353-.14329.19457.19457,0,0,1-.2523-.04582L86.164,131.025l-.79979.24164A.28941.28941,0,0,0,85.19176,131.40791Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M85.22254,130.7982l.5578-.16851a.678.678,0,0,0-.36288-.0831l-2.175.12082a.67935.67935,0,0,0-.56153.35825l-.40481.75807a.96626.96626,0,1,0,1.72119.87795l.76307-1.48492A.77577.77577,0,0,1,85.22254,130.7982Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M86.73292,136.21283l-.89118.01323a.19454.19454,0,0,1-.19662-.1768l-.00758-.08282a.11419.11419,0,0,0-.20938-.052l-.65373,1.00362a.42.42,0,0,0-.01046.44157l.54667.93339a.11419.11419,0,0,0,.21225-.04714.19451.19451,0,0,1,.18618-.17631l1.14128-.044.27817-.78784a.28959.28959,0,0,0-.01193-.22256Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M88.90976,135.2166l-.37187-.77477a.96627.96627,0,1,0-1.7259.86872l.74612,1.49353a.77567.77567,0,0,1,.0319.59655l-.194.54944a.678.678,0,0,0,.28163-.24349l1.1889-1.8253A.67932.67932,0,0,0,88.90976,135.2166Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-21"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M122.61068,141.36806a6.87687,6.87687,0,1,1,6.60009-7.143A6.8847,6.8847,0,0,1,122.61068,141.36806Zm-.521-13.19a6.32336,6.32336,0,1,0,6.568,6.06883A6.33057,6.33057,0,0,0,122.08965,128.17809Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M123.836,134.77406l2.28321-.09019-.60951-2.58115a.30146.30146,0,0,0-.30532-.232l-4.21873.16665a.09445.09445,0,0,0-.02462.18447l2.54755.8016a.30155.30155,0,0,1,.21008.2639Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M124.46118,131.56505a.82582.82582,0,1,0-.85776-.79259A.82583.82583,0,0,0,124.46118,131.56505Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M126.35339,138.64564l-.22714-3.78409-2.2688.08963-1.188,3.90674a.09446.09446,0,0,0,.1639.08679l1.9602-2.43063,1.32092,2.20543A.12874.12874,0,0,0,126.35339,138.64564Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M121.52481,139.02219l-1.72438.06811a.56108.56108,0,0,1-.57228-.46035l-.733-4.10985a.55884.55884,0,0,1,.52815-.65662l2.86389-.11313a.55894.55894,0,0,1,.57834.61285l-.40651,4.155A.56125.56125,0,0,1,121.52481,139.02219Zm-2.47965-4.60563-.00512.00634.733,4.1099.00554.00444,1.72438-.06811.00521-.005.40652-4.15484-.00564-.00591Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M120.36914,139.06788a.27679.27679,0,0,1-.28522-.24226l-.58482-4.68049a.27678.27678,0,0,1,.54929-.06864l.58479,4.68048a.27677.27677,0,0,1-.24032.30893Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M121.117,139.0383q-.00954.00037-.0193.00013a.27678.27678,0,0,1-.26851-.28476l.13822-4.709a.27675.27675,0,1,1,.55327.01622l-.13821,4.70908A.27677.27677,0,0,1,121.117,139.0383Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M122.089,135.75756l-3.10854.12279a.27675.27675,0,0,1-.02185-.55306l3.10854-.12279a.27675.27675,0,1,1,.02185.55306Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M122.05827,134.97936l-3.10854.12279a.27675.27675,0,0,1-.02185-.55306l3.10854-.12279a.27675.27675,0,1,1,.02185.55306Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M121.97373,136.51606l-2.88247.11386a.27754.27754,0,0,1-.02185-.55306l2.88248-.11386a.27753.27753,0,0,1,.02184.55306Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M121.77153,137.51581l-2.44373.09653a.27675.27675,0,1,1-.02185-.55306l2.44373-.09653a.27675.27675,0,0,1,.02185.55306Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M119.79419,133.05956l1.578-.39057a.0966.0966,0,0,1,.09255.161l-.734.7568a.0966.0966,0,0,1-.12281.01321Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.a780debf7ad6e430a35d8b452346813e.svg";
export { ForwardRef as ReactComponent };